<template>
    <div class="home container mt-5 pt-5">
        <div class="row justify-content-center">
            <div class="col-md-12">
                <img :src="base_url + '/files/images/ph04.png'" class="displaypc" style="width: 100%;">
                <img :src="base_url + '/files/images/ph04m.png'" class="displaymb" style="width: 100%;">
                <div id="home" class="tab-pane fade show active">
                    <form style="padding: 20px; background-color:#fff;border: 1px solid rgba(0, 0, 0, 0.125);"
                        v-on:submit.prevent="userlogin">
                        <h3><b>使用者登入</b></h3>
                        <div class="form-group">
                            <label for="exampleInputtext1">帳號</label>
                            <input type="text" class="form-control" id="exampleInputEmail" aria-describedby="emailHelp"
                                placeholder="請輸入帳號" required="required" v-model="username">
                        </div>
                        <div class="form-group">
                            <label for="exampleInputPassword1">密碼</label>
                            <input type="password" class="form-control" id="exampleInputPassword0" placeholder="請輸入密碼"
                                required="required" v-model="password">
                        </div>
                        <div id="error-passwd"></div>

                        <button type="submit" class="btn btn-primary btn-lg btn-block">登入</button>
                        <div style="text-align: center; margin-top: 10px;">
                            <a href="http://py3.ponysys.com.tw/MemberCreate.aspx?id=-1" style="text-align: center;"
                                class="text-primary">會員註冊</a>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    props: ['nextPage'],
    data() {
        return {
            base_url,
            username: '',
            password: '',
        }
    },
    methods: {
        userlogin: function () {
            let component = this;
            axios
                .post(base_url + '/api/user/login', {
                    username: this.username,
                    password: this.password,
                })
                .then((response) => {
                    if (response.data.message == "Login success.") {
                        Turbolinks.visit(component.nextPage);
                    }
                })
                .catch(function (error) {
                    if (error.response.data.error) {
                        alert("帳號或密碼錯誤");
                    }
                });
        }
    }
}
</script>
<style scoped>
.home {
    min-height: 680px;
}

@media only screen and (max-width: 991px) {
    .displaypc {
        display: none;
    }
}

@media only screen and (min-width: 992px) {
    .displaymb {
        display: none;
    }
}
</style>
